import React, { useState } from 'react';
import Css from './Error404.module.css';
import { Link } from 'react-router-dom';
import phone from "./../../img/phone.png";
import telegram from "./../../img/telegram.png";
import error404 from "./../../img/404.jpg";

const Error404 = () => {
    const Searsh = () => {
        return;
      };
    return (
        <div className={Css.content}>
            <div className={Css.contentError}>
                <h1>Ошибка 404 - Страница не найдена</h1>
                <div className={Css.tagCloud}>
                    <div className={Css.marg10}>
                    <Link to="/">Главная</Link>
                    <Link to="/catalog/">Каталог</Link>
                    <Link to="https://organza.ru/contacts/">Контакты</Link>
                    <Link to="/catalog/?filter[class][]=342&sort_by=SHOW_COUNTER&sort_dir=desc&page=1&countItems=48">Распродажа</Link>
                    <Link to="https://organza.ru/pages/articles/help-pay">Заказ, оплата и доставка</Link>
                    <Link to="https://organza.ru/collections/">Ткани по поставщикам</Link>
                    <Link to="/catalog/?page=1&countItems=48&sort_by=id&sort_dir=desc">Новинки</Link>
                    </div>
                </div>
                <br></br>
                <br></br>
                <div className={Css.margSearch}>
                    <input
                    className={Css.searshIndexOrganza}
                    type="text"
                    id="title-search-input-destop"
                    placeholder="Какую ткань вы ищете?"
                    value=""
                    name="tag"
                    onChange={Searsh}
                    />
                    <div className={Css.searshIdexOrganzaBefore} rel="Search"></div>
                </div>
                <br></br>
                <div className={Css.tagCloud}>
                    <div className={Css.marg10}>
                    <Link to="/catalog/?filter[cathegory][]=338">Портьерные</Link>
                    <Link to="/catalog/?filter[cathegory][]=339">Тюлевые</Link>
                    <Link to="/catalog/?filter[cathegory][]=340">Мебельные</Link>
                    <Link to="/catalog/?filter[class][]=342&sort_by=SHOW_COUNTER&sort_dir=desc&page=1&countItems=48">Для скатерти</Link>
                    <Link to="/catalog/?filter[cathegory][]=1285">Для покрывала</Link>
                    </div>
                </div>
                <div className={Css.socialBlocs}>
                    <p className={Css.pageCentr}>
                    <a href="tel:+74959707730">
                        <img
                        className={Css.logoSocial}
                        src={phone}
                        alt="Телефон для связи"
                        title="Телефон"
                        />
                    </a>
                    <a href="//wa.me/79859707730">
                        <img
                        className={Css.logoSocial}
                        src="//organza.ru/pages/contacts/messengers/whatsapp.png"
                        alt="WhatsApp для связи"
                        title="WhatsApp"
                        />
                    </a>
                    <a href="https://t.me/organzaru">
                        <img
                        className={Css.logoSocial}
                        src={telegram}
                        alt="Telegram для связи"
                        title="Telegram"
                        />
                    </a>
                    </p>
                </div>
                <div className={Css.contentImageBlock}>
                    <img
                            className={Css.contentImg}
                            src={error404}
                            alt="404 - Страница не найдена"
                            title="404 - Страница не найдена"
                            />  
                </div>
            </div>
        </div>
    )
}

export default Error404;